var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table-header-actions-list" },
    [
      _c(
        "transition",
        { attrs: { name: "fade", mode: "out-in" } },
        [
          Array.isArray(_vm.actions) && _vm.actions.length && _vm.show
            ? _c(
                "b-button-toolbar",
                {
                  attrs: {
                    "key-nav": "",
                    "aria-label": "Управление выбранными элементами"
                  }
                },
                [
                  _c(
                    "b-button-group",
                    { staticClass: "mx-1", attrs: { size: "sm" } },
                    [
                      _vm.actions.length <= _vm.collapseCount
                        ? _vm._l(_vm.actions, function(action) {
                            return !action.disabled
                              ? _c(
                                  "b-button",
                                  {
                                    key: action.name,
                                    attrs: { variant: "light", size: "sm" },
                                    on: {
                                      click: function($event) {
                                        return _vm.doAction(action)
                                      }
                                    }
                                  },
                                  [
                                    _vm.windowWidth < 1024
                                      ? _c("i", {
                                          staticClass: "far ",
                                          class: "fa-" + action.icon
                                        })
                                      : _vm._e(),
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.windowWidth >= 1024
                                            ? action.title
                                            : ""
                                        ) +
                                        "\n                        "
                                    )
                                  ]
                                )
                              : _vm._e()
                          })
                        : [
                            _vm._l(_vm.collapseCount, function(key) {
                              return !_vm.actions[key - 1].disabled
                                ? _c(
                                    "b-button",
                                    {
                                      key: _vm.actions[key - 1].name,
                                      attrs: { variant: "light", size: "sm" },
                                      on: {
                                        click: function($event) {
                                          return _vm.doAction(
                                            _vm.actions[key - 1]
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm.windowWidth < 1024
                                        ? _c("i", {
                                            staticClass: "far ",
                                            class:
                                              "fa-" + _vm.actions[key - 1].icon
                                          })
                                        : _vm._e(),
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm.windowWidth >= 1024
                                              ? _vm.actions[key - 1].title
                                              : ""
                                          ) +
                                          "\n                        "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            }),
                            _vm._v(" "),
                            _c(
                              "b-dropdown",
                              {
                                attrs: {
                                  text: "Еще",
                                  size: "sm",
                                  variant: "light",
                                  "no-caret": ""
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "button-content",
                                      fn: function() {
                                        return [
                                          _c("i", {
                                            staticClass: "fas fa-ellipsis-v"
                                          })
                                        ]
                                      },
                                      proxy: true
                                    }
                                  ],
                                  null,
                                  false,
                                  3452768261
                                )
                              },
                              [
                                _vm._v(" "),
                                _vm._l(
                                  _vm.actions.length - _vm.collapseCount,
                                  function(key) {
                                    return _c(
                                      "b-dropdown-item",
                                      {
                                        key:
                                          _vm.actions[
                                            key + _vm.collapseCount - 1
                                          ].name,
                                        on: {
                                          click: function($event) {
                                            return _vm.doAction(
                                              _vm.actions[
                                                key + _vm.collapseCount - 1
                                              ]
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.actions[
                                                key + _vm.collapseCount - 1
                                              ].title
                                            ) +
                                            "\n                            "
                                        )
                                      ]
                                    )
                                  }
                                )
                              ],
                              2
                            )
                          ]
                    ],
                    2
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }